export enum ImageAssetType {
  Picture = "picture",
  Icon = "icon",
}
